import type { DocumentInput, AnyVariables, Client, RequestPolicy } from '@urql/core';

export const gqlQuery = async <T, V = Record<string, unknown>>(
  client: Client, 
  query: DocumentInput<T, AnyVariables>,
  input: V,
  callback = () => {},
  fetchOptions?: RequestInit,
  requestPolicy: RequestPolicy = 'network-only',
): Promise<T | null> => {
  try {
    const result = await client.query<T, V>(query, input, {
      requestPolicy,
      ...(fetchOptions && {
        fetchOptions: () => ({
          ...fetchOptions,
        }),
      }),
    }).toPromise();

    if (result.error) {
      callback();
      return null;
    }

    return result.data ?? null;
  } catch {
    callback();
    return null;
  }
};

export const gqlMutation = async <T, V = Record<string, unknown>>(
  client: Client, 
  mutation: DocumentInput<T, AnyVariables>,
  input: V,
  callback: () => void,
  fetchOptions?: RequestInit,
  requestPolicy: RequestPolicy = 'network-only',
): Promise<T | null> => {
  try {
    const result = await client.mutation<T, V>(mutation, input, {
      requestPolicy,
      ...(fetchOptions && {
        fetchOptions: () => ({
          ...fetchOptions,
        }),
      }),
    }).toPromise();

    if (result.error) {
      callback();
      return null;
    }

    return result.data ?? null;
  } catch {
    callback();
    return null;
  }
};
